export const settingsApiErrorCode: Record<string, string> = {
  INTERNAL_SERVER_ERROR: 'internalServerError',
  BAD_REQUEST: 'badRequest',
  MAXIMUM_UPLOAD_SIZE_EXCEEDED: 'maximumUploadSize',
  FORMAT_NOT_SUPPORTED: 'formatNotSupported',
  APPLICATION_DEFAULT_LOGO_NOT_CONFIGURED: 'defaultLogoNotConfigured',
  APPLICATION_DEFAULT_FAVICON_NOT_CONFIGURED: 'defaultFaviconNotConfigured',
};
